module.exports = __webpack_public_path__ + "img/arrow-down.d1b3ec75.svg";